export class BscFormulaVariableEntity{
    id:number;
    formulaId:number;
    type:string;
    variableId:number;
    variable:string;

    constructor(){}
}